module.exports = __webpack_public_path__ + "img/the-rugby-company-thumbnail.b4a7cda7.jpg";